// extracted by mini-css-extract-plugin
export default {"min":"OPDCNews_min__7voR5","pointer":"OPDCNews_pointer__ZNN-+","text_red":"OPDCNews_text_red__06TRZ"};